(function () {
    class LocalAuthenticationStrategy {
        constructor (config) {
   
            this.storageId = config.localStorageId;

            console.log("LocalAuthenticationStrategy", this.storageId)
        }

        login (email, password) {
            localStorage.setItem(this.storageId, JSON.stringify({email, loggedIn:true}));
            return Promise.resolve();
        }
        logout () {
            // delete local storage entry
            localStorage.removeItem(this.storageId);
            return Promise.resolve();
        }
        isAuthenticated () {

            const stored = localStorage.getItem(this.storageId)



            return  (stored !== null && stored !== undefined && stored !== "" && JSON.parse(stored).loggedIn)
        }
        user () {
            return JSON.parse(localStorage.getItem(this.storageId));
        }
    }

    AuthenticationProvider.add("LocalAuthenticationStrategy", (config) => {
        console.log("creating new LocalAuthenticationStrategy")
        return new LocalAuthenticationStrategy(config);
    })
}());
(function () {
    class NullAuthenticationStrategy {
        constructor(config) {}
        login(email, password) {
            return Promise.resolve();
        }
        logout() {
            return Promise.resolve();
        }
        isAuthenticated() {
            return true;
        }
        user() {
            return { email: null };
        }
    }
    AuthenticationProvider.add("NullAuthenticationStrategy", (config) => {
        return new NullAuthenticationStrategy(config);
    });
})();
;

class LocalDataAccessStrategy {

    constructor (options) {
        this.options = options;
        this.manifest = null;
        this.scenesCfg = [];
    }

    async loadJson(url) {
        return fetch(url).then((o) => o.json());
    }

    async decorateJsonLoader(id, url) {


        var data
        try {

            data = await this.loadJson(url);
        }catch (e) {
            throw Error(`${e.message} - in file: ${url}`)
        }
        return Promise.resolve({id, data});
    }

    async fetch () {
        
        // load manifest
        this.manifest = await this.loadJson(this.options.manifest);

        return new Promise((resolve, reject) => {
            // load all scenes 
            Promise.all(this.manifest.scenes.map(o => this.decorateJsonLoader(o.id, o.url)))
            .then(data => {
                this.scenesCfg = data;
                resolve(data);
            })
            .catch(e => {
                reject(e)            
            })
        })
    }

    scenes () {
        return this.manifest.scenes.concat();
    }

    sceneConfig (id) {
        if(this.scenesCfg.some(s => s.id === id))
            return this.scenesCfg.find(s => s.id === id);
        throw Error(`Can't find scene with id: "${id}"`);
    }
};

DataProvider.add("LocalDataAccessStrategy", (options) => {
    return new LocalDataAccessStrategy(options);
});
(function () {
    class LocalTrackingStrategy {
        constructor () {
            this.storageid = "touchkit.tracking";
            if(!localStorage.getItem(this.storageid))
                localStorage.setItem(this.storageid, "[]");
        }

        log(user, event, data) {
            
            const currentState = JSON.parse(localStorage.getItem(this.storageid));
            currentState.push({
                event,
                ...data,
                time: new Date().toISOString(),
                user,
               
            })
            localStorage.setItem(this.storageid, JSON.stringify(currentState));

        }

        clear () {
            localStorage.removeItem(this.storageid);
        }
    }
    
    TrackingProvider.add("LocalTrackingStrategy", (properties) => {
        return new LocalTrackingStrategy(properties);
    })
}());

;
(function () {
    class NullTrackingStrategy {
        constructor () {}
        log(user, event, data) {}
        clear () {}
    }
    TrackingProvider.add("NullTrackingStrategy", (properties) => {
        return new NullTrackingStrategy(properties);
    })
}());

;

class LocalTranslationStrategy {
    constructor (options) {
        this.url = options.file.replace("@lang", options.lang);
    }
    async loadJson(url) {
        return fetch(url).then((o) => o.json());
    }

    async fetch () {
        
        this.translations = await this.loadJson(this.url);
        return Promise.resolve();
    }
    
    get (value) {

        if (!/\@string:/.test(value)) return value;
        
        const id = value.replace(/\@string:/, "");

        var trans = Object.keys(this.translations);

        if (trans.some((key) => key === id)) {
            return this.translations[id];
        } else {
            return `[Translation Error missing id: (${id})]`;
        }
    }
}


TranslationsProvider.add("LocalTranslationStrategy", (options) => {
    return new LocalTranslationStrategy(options)
});;

class NullTranslationStrategy {
    constructor (options) {}
    get (id) {return id; }
    fetch () {
        return Promise.resolve();
    }
}

TranslationsProvider.add("NullTranslationStrategy", (options) => {
    return new NullTranslationStrategy(options)
});;
const Banner = {
    props: ["componentId", "sceneId", "state", "static"],
    mixins: [touchKit.BaseComponentBehaviorMixin],
    template: `
        <div v-if="visible" class="Banner" :class="applyObjectCssClasses()">
            <img :src="state.img"/>
        </div>
    `,

    data() {
        return {
            visible: this.state.visible == true,
        };
    },
    mounted () {
        this.api.ready();
    },
    
};
window.registerBaseComponentConfiguration("Banner", {img: ""})
;
Vue.component("CanvasHotspot", {
  props: ["id", "hotspot", "transitionState", "beforeTransitionInCalled", "afterTransitionInCalled"],
  template: `
        <li class="canvas-hotspot" :class="{'reverse': hotspot.reverse}">
            <div class="canvas-hotspot-background">
                <canvas></canvas>
                <div class="canvas-hotspot-text-container">
                    <div class="canvas-hotspot-label">{{hotspot.text}}</div>
                </div>
            </div>
            <div class="canvas-hotspot-face"></div>
        </li>
   `,

 

  mounted () {

    // console.log("mounted: beforeTransitionInCalled")


    // var textWidth = this.calculateTextWidth();
    // var container = this.$el;
    // let height = container.getBoundingClientRect().height;
    // let width = textWidth + 2 * height;


    // console.log(`
    //     textWidth: ${textWidth},
    //     container: ${container},
    //     height: ${height},
    //     width: ${width},
    
    // `)


    this.render();


  },



  methods: {

    render () {


        
        var textWidth = this.calculateTextWidth();
        var container = this.$el;
        var scale = container.getBoundingClientRect().width / container.offsetWidth;
            scale = Math.ceil(scale*1000)/1000;
      
            
        const calcScale = (s) => {
          return s < 2 ? (1 + (1 - s)) : 1/s;
        }


        let height = container.getBoundingClientRect().height * calcScale(scale);
        let width = (textWidth + 2 * height);
        let radius = height / 2;

        // update label posiiton
        // container.querySelector(".canvas-hotspot-text-container").style = `width: calc(100% - ${height}px);`;
  
        const canvas = container.querySelector("canvas");
        canvas.width = width - radius;
        canvas.height = height;
        canvas.style.background = "transparent";
  
        const ctx = canvas.getContext("2d");
        ctx.fillStyle = this.hotspot.color || "#08a0e1d4";
        ctx.translate(-radius, -radius);
        ctx.beginPath();
        ctx.arc(height, height, radius, 0, Math.PI * 2);
        ctx.rect(height, radius, width - height, height);
        ctx.fill();
        ctx.beginPath();
        ctx.fillStyle = "black";
        ctx.arc(width, height, 25, 0, Math.PI * 2);
        ctx.globalCompositeOperation = "destination-out";
        ctx.fill();
    },

    calculateTextWidth() {
      var lblText = this.hotspot.text;
      const text = document.createElement("div");
      text.classList.add("canvas-hotspot-label");
      text.innerHTML = lblText;
      text.style.visibility = "hidden";
      document.body.appendChild(text);
      var textWidth = text.getBoundingClientRect().width;
      text.remove();
      return textWidth;
    },
  },
});
;
Vue.component("TkSlider", {

    props: ["elements", "startindex"],

    data() {
        return {
            currentIndex: parseInt(this.startindex) || 0,
            direction: 'right',
            animations: {
                right: {
                    enter: 'animated slideInLeft transition-duration-short',
                    leave: 'animated slideOutRight transition-duration-short',
                },
                left: {
                    enter: 'animated slideInRight transition-duration-short',
                    leave: 'animated slideOutLeft transition-duration-short',
                },
            }
        }
    },

    template: `
        <div class="tk-slider" >
            <div class="tk-slider__slide_container">
                <transition
                    name="slide"
                    :enter-active-class="animations[direction].enter"
                    :leave-active-class="animations[direction].leave">

                    <div class="tk-slider__slide_container__slide" v-for="(item, index) in elements" :key="index" v-if="index===currentIndex">
                        <slot v-bind:cfg="item"></slot>
                    </div>
                </transition>
            </div>
            <div class="tk-slider__controls" v-if="hasMultipleSlides">
                <div @click="prev()" class="tk-slider__controls__prev" :class="getPrevClass">
                    <div class="icon-left-open"></div>
                </div>
                <div @click="next()" class="tk-slider__controls__next" :class="getNextClass">
                    <div class="icon-right-open"></div>
                </div>
            </div>
            <div class="tk-slider__pagination" v-if="hasMultipleSlides">
                <div class="tk-slider__pagination__item" v-for="(o, i) in elements" :key="i" :class="{'current': i === currentIndex}" @click="goto(i)"></div>
            </div>
        </div>
    `,


    mounted () {
        const hammertime = new Hammer(this.$el, {});
        this.hammertime = hammertime;
        hammertime.on("swipeleft", () => {
          this.next();
        });
        hammertime.on("swiperight", () => {
          this.prev();
        });
    },

    destroy () {
        this.hammertime.destroy();
    },

    computed: {
        getPrevClass() {
            return this.hasPrev ? 'has-prev' : 'has-not-prev';
        },
        getNextClass() {
            return this.hasNext ? 'has-next' : 'has-not-next';
        },
        hasPrev() {
            return (this.currentIndex - 1 >= 0)
        },
        hasNext() {
            return this.currentIndex + 1 < this.elements.length;
        },
        hasMultipleSlides () {
            return this.elements.length > 1
        }
    },

    methods: {
        next() {
            this.direction = 'left';
            if (this.currentIndex + 1 < this.elements.length) {
                this.currentIndex += 1;
            }
        },
        prev() {
            this.direction = 'right';
            if (this.currentIndex - 1 >= 0) {
                this.currentIndex -= 1;
            }
        },
        goto (index) {
            this.direction = index > this.currentIndex ? "left" : "right";
            this.currentIndex = index;
        } 
    }
})
;
// http://grsmto.github.io/simplebar/
Vue.component("TKTextScroll", {
    template: `
        <div class="TKTextScroll">
            <slot></slot>
        </div>
    `,
    mounted () {
        this.simpleBar = new SimpleBar(this.$el);
    },

    destroyed () {
        if(this.simpleBar) this.simpleBar.unMount();
    }
});
Vue.component("GuyHotspot", {
    props: ["id", "hotspot"],
    template: `
        <li class="GuyHotspot">
            <img :src="hotspot.img" />
        </li>
    `,
});
const GuyPopup = {
  props: ["componentId", "sceneId", "state", "static"],
  mixins: [touchKit.BaseComponentBehaviorMixin],
  template: `
		<div v-if="visible" class="GuyPopup" :class="applyObjectCssClasses()">

			<div class="btn back" @click="onCloseClicked"></div>

			<div class="row overflow-hidden">
				<div class="col-50 align-flex-end " >
					<video :src="state.src" autoplay muted loop playsinline />	
				</div>
				<div class="col-50 align-flex-start" style='backface-visibility: hidden;'>
					<div class="textContent" v-html="state.text"></div>
				</div>
			</div>
			
		</div>
    `,

	data() {
		return {
			// visible: this.state.visible === true
		};
	},
	mounted() {
		this.api.ready();
	},
	methods: {
		onCloseClicked() {
            if (this.static.closeState) {
                if (this.static.closeState.global)
                    app.radio.$emit("setState", this.static.closeState.global);
                if (this.static.closeState.local)
                    app.radio.$emit("setStates", [
                        `${this.componentId}:${this.static.closeState.local}`,
                    ]);
            }
        },
	},
	computed : {
		visible () {
			return this.state.visible
		}
	}
};
window.registerBaseComponentConfiguration("GuyPopup", { text: "", src: "" });
;
const Minimap = {
    props: ["componentId", "sceneId", "state", "static"],
    mixins: [touchKit.BaseComponentBehaviorMixin],
    template: `
        <div v-if="visible" class="Minimap" :class="applyObjectCssClasses()">
            <div class="title" >{{state.title}}</div>
            <div class="location" :style="state.location"></div>
            <img src="assets/img/minimap.png" class="img">
            <div class="btn back" @click="onBackClicked"></div>
        </div>
    
    `,
    data() {
        return {
            visible: this.state.visible == true,
        };
    },
    mounted () {
        this.api.ready();
    },
    methods: {
        onBackClicked () {
            // could be configured to take a route if need be.
            app.vm.$router.push("/scene/index")            
        }
    }
};
window.registerBaseComponentConfiguration("Minimap", {})
;
const TKText = {
    props: ["componentId", "sceneId", "state", "static"],
    mixins: [touchKit.BaseComponentBehaviorMixin],
    template: `<div class="TKText" v-html="state.text" v-if="state.visible" :class="applyObjectCssClasses()"></div>`,
    mounted () {
        this.api.ready();
    },
};
window.registerBaseComponentConfiguration("TKText", {text: ""})

;

const TkComplexComponent = {
    props: ["componentId", "sceneId", "state", "static"],
    mixins: [touchKit.BaseComponentBehaviorMixin],
    template: `<div class="TkComplexComponent"></div>`,

    mounted() {
        const self = this;
        let api = new ComponentInternalApi(this, this.componentId, this.$parent.$parent.sceneId, app);
        this.api = api;
        this.win =  null;

        this.eventProxyHandlers = {};
        const componentCfg = app.data.cache.components.get(this.sceneId, this.componentId);

        this.eventHandlers = {
            "component-ready": (cid) => {
                if (this.componentId === cid) {
                    console.log(this.componentId, "ready");
                    this.contentWindow.onReady();
                    this.api.log("unbinding component-ready handler")
                    app.radio.$off("component-ready", this.eventHandlers["component-ready"]);
                }
            }
        };

        app.radio.$on("component-ready", this.eventHandlers["component-ready"]);

        return new Promise((resolve, reject) => {
   
            const cfg = componentCfg.static;
            var frame = document.createElement("iframe");
            frame.onload = function () {
                self.contentWindow = frame.contentWindow;

                let win = self.contentWindow;
                self.win = win;

                // overwrite logging
                win.console.log = (...messages) => {
                    api.log(...messages);
                };
                win.console.warn = (...messages) => {
                    api.log(...messages)
                }
                win.console.error = (...messages) => {
                    api.log(...messages);
                }

                ["initialize", "destroy", "onStateChange", "afterInitialize", "onReady"].forEach(
                    (fnName) => {
                        if (!win.hasOwnProperty(fnName)) {
                            throw new Error(
                                `\n[Component Implementation Error]\nComponent "${self.componentId}" missing "${fnName}" function in frame: "${cfg.src}"`
                            );
                        }
                    }
                );

                win.initialize(api, self.state.id);
                frame.onload = null;


                ["click", "mousedown", "mouseup", "touch", "touchend"].forEach(event => {
                    
                    self.eventProxyHandlers[event] = () => {
                        console.log(self.componentId, "triggered event => ", event);

                        app.radio.$emit("TKComplexComponentProxyEvent", {
                            event,
                            componentId: self.componentId
                        })                        
                    }

                    win.addEventListener(event, self.eventProxyHandlers[event]);
                })

                setTimeout(resolve, 0);
            };

            frame.setAttribute("src", cfg.src);
            frame.style.width = cfg.width || "100%";
            frame.style.height = cfg.height || "100%";
            this.$el.appendChild(frame);
        });
    },

    destroyed() {
        this.api.destroy();
        app.radio.$off("component-ready", this.eventHandlers["component-ready"]);

        ["click", "mousedown", "mouseup", "touch", "touchend"].forEach(event => {
            this.win.removeEventListener(event, this.eventProxyHandlers[event]);
        })

    },
};

window.registerBaseComponentConfiguration("TkComplexComponent", { src: "" });
Vue.component("TKHotspot", {

    props: ["id", "hotspot"],

    template: `
        <li class="tk-hotspot" >

            <!-- face -->
            <div class="tk-hotspot__face-before"></div>
            <div class="tk-hotspot__face">
                <i class="tk-hotspot__face__icon"  :class="hotspot.icon"></i>
            </div>    
            <div class="tk-hotspot__face-after"></div>

            <!-- label -->
            <div class="tk-hotspot__tekst-before"></div>
            <div class="tk-hotspot__tekst"  v-if="hotspot.text && hotspot.text!== '' "><p v-html="hotspot.text"></p></div>
            <div class="-tk-hotspot__tekst-after"></div>
        </li>
    `

});
const TKHotspotRenderer = {
    props: ["componentId", "sceneId", "state", "static"],
    mixins: [touchKit.BaseComponentBehaviorMixin, touchKit.BaseComponentTransitionsBehavior],
    template: `
        <div class="TKHotspotRenderer" v-if="state.visible" :class="applyObjectCssClasses()">
            <transition-group
                name="staggered-fade"
                tag="ul"
                class="hotspot-container"
                v-on:before-enter="beforeEnter"
                v-on:enter="enter"
                enter-active-class="animate__animated animate__fadeIn"
                leave-active-class="animate__animated animate__fadeOut animation-duration-250ms" 
                v-on:after-enter="afterEnterCssHook"
                v-on:after-leave="afterLeaveCssHook">
                    <component 
                        v-for="(hotspot, index) in hotspotsList" 
                        :id="hotspot.id"
                        :hotspot="hotspot.properties"
                        :is="hotspot.type" 
                        :key="hotspot.id" 
                        :class="createClasses(hotspot)" 
                        :style="getHotspotPosition(hotspot.id)"
                        :data-index="index" 
                        :beforeTransitionInCalled="beforeTransitionInCalled"
                        :afterTransitionInCalled="afterTransitionInCalled"
                        :transitionState="transitionState"
                        @click.native ="onClicked(hotspot)"   
                    ></component>
            </transition-group>  
        </div>
    `,
    data () {
        return {
            hotspots: this.static.hotspots || [],
            beforeTransitionInCalled: false,
            afterTransitionInCalled: false
        }
    },
    mounted() {
        this.api.ready();
        // allow the hotspot render to render other components hotspots
        // if they have the correct master/origin

       
       // app.radio.$on("render-hotspots", ({ origin, hotspots }) => {
        this.api.bindings.add("render-hotspots", ({ origin, hotspots }) => {
            // console.log("renderHotspots called from origin", origin, this.static.master, hotspots);
            if(this.static.master === origin) {
 
                if(!this.hotspots.length) {

                    this.hotspots = hotspots;
                }
                else {
                    this.hotspots.forEach(o => {

                        var hs = hotspots.find(h => h.id === o.id);

                        if(hs) {
          
                            o.visible = hs.visible;
                            o.position = hs.position;
                        }else {
                            console.log("cant find hotspot id=", o.id, this.hotspots, hotspots)
                        }
                    })
                }
            }
        });
    },
    computed: {
        hotspotsList() {
            if (this.transitionState == "transitionIn" ) 
                return this.hotspots.filter(o => o.visible)
            else return [];
        }
    },
    methods: {


        beforeEnter () {
            console.log("beforeEnter", this.$el.querySelector(".hotspot-container").style.transform )
        },
        enter () {
            this.$nextTick(()=> {
                console.log("enter",  this.$el.querySelector(".hotspot-container").classList);
            })
        },
        beforeTransitionIn() {
            this.beforeTransitionInCalled = true;
            return Promise.resolve();
        },
        afterTransitionIn() {
            this.afterTransitionInCalled = true;
            console.log("afterTransitionIn ... ")

            return Promise.resolve();
        },


        onClicked (hotspot) {
            console.log("hotspot clicked", hotspot)
            this.resolveClick(hotspot)
        },
        createClasses(hotspot) {
            if (hotspot.authRequired && !app.authentication.isAuthenticated()) {
                return "hidden"
            }
            return [ 
                {
                    'selected': hotspot.id === this.state.id, 
                    'hidden': !hotspot.visible,
                    'visible': hotspot.visible,
                    'disabled': hotspot.disabled
                }, 
                'tk-hotspot-label-direction--' + (hotspot.properties.labelDirection ? hotspot.properties.labelDirection.toLowerCase(): "right"),
                hotspot.typeClass
            ]
        },
        decorateUnit (val) {
            return /px|%$/.test(val) ? val : `${val}px`;
        },
        getHotspotPosition(id) {
            let position = this.hotspots.find((x) => x.id == id).position;
            let style = {};

            if(position.hasOwnProperty("top") || position.hasOwnProperty("y"))
                style.top = this.decorateUnit(position.top||position.y);

            if(position.hasOwnProperty("left") || position.hasOwnProperty("x"))
                style.left = this.decorateUnit(position.left||position.x);

            if(position.hasOwnProperty("right"))
                style.right = this.decorateUnit(position.right);

            if(position.hasOwnProperty("bottom"))
                style.bottom = this.decorateUnit(position.bottom);
            
            return style;
        },
    }
   
};


window.registerBaseComponentConfiguration("TKHotspotRenderer", {hotspots: []});
const TKImage = {
    props: ["componentId", "sceneId", "state", "static"],
    mixins: [touchKit.BaseComponentBehaviorMixin],
    template: `<img class="TKImage" :src="state.src" v-if="state.visible" :class="[applyObjectCssClasses(), {'hidden': hide}]" :style="applyObjectStyles()" />`,
    data () {
        return {
            hide: false
        }
    },
    mounted () {
        this.api.ready();

        app.radio.$on("TK2-COMPONENT-2D-ORBIT-ROTATE-START", () => {
            this.hide = true
        })
        app.radio.$on("TK2-COMPONENT-2D-ORBIT-ROTATE-END", () => {
            this.hide = false
        })


        
        this.eventHandlers = {
            "TKComplexComponentProxyEvent": (e) =>  {
                if(e.event === "mousedown") {
                    this.hide = true
                }
            }
        }

        app.radio.$on("TKComplexComponentProxyEvent",  this.eventHandlers["TKComplexComponentProxyEvent"]);


        if(this.componentId === "rotateIcon") {
            setTimeout(()=> {
                this.hide = true;
            }, 5000)
        }
        

    },

    destroyed () {
        app.radio.$off("TKComplexComponentProxyEvent",  this.eventHandlers["TKComplexComponentProxyEvent"]);
    },

    methods: {
        applyObjectStyles () {
            return this.state.style
        }
    }
};
window.registerBaseComponentConfiguration("TKImage", {src: ""})

;
const TK2dOrbit = {

  mixins: [TkComplexComponent],

  mounted() {

    this.eventHandlers = {
      "idle-screen-before-close": () => {
        app.radio.$emit("2D_ORBIT_RESET")
      }
    }


    app.radio.$on("idle-screen-before-close",  this.eventHandlers['idle-screen-before-close'])
  },

  destroyed() { 
    app.radio.$off("idle-screen-before-close",  this.eventHandlers['idle-screen-before-close'])
  }

};

window.registerBaseComponentConfiguration("TK2dOrbit", { src: "" });
const TKPopup = {
    props: ["componentId", "sceneId", "state", "static"],
    mixins: [touchKit.BaseComponentBehaviorMixin],
    template: `
        <transition name="popupanimation"
            :key="state.id || 0 "
            enter-active-class="animate__animated animate__zoomIn animation-duration-250ms"
            leave-active-class="animate__animated animate__zoomOut animation-duration-250ms"
            v-on:after-enter="animationComplete"
            v-on:after-leave="animationComplete"

        >
            <div v-if="visible" class="TKPopup" :class="applyObjectCssClasses()">
                <div class="close" @click="onCloseClicked"></div>
                <div class="TKPopup__innerwrapper">

                
                <div class="imageContainer" v-if="hasImage()">

                <tk-slider :elements="state.img" startindex="0">

                    <!-- Each slide will be rendered using this template, and properties-->
                    <template v-slot:default="data" class="">
                        <div class="SlideAndText_slide_item">
                            <img :src="data.cfg" />
                        </div>
                    </template>
                    
                </tk-slider>

                </div>                
                <div class="text" v-html="state.text"></div>
                </div>
            </div>
        </transition>
    `,

    data() {
        return {
            visible: this.state.visible == true,
        };
    },
    mounted() {
        this.api.ready();

        this.eventHandlers = {
            "TKComplexComponentProxyEvent": (e) =>  {
                if(e.event === "mousedown") {
                    this.onCloseClicked();
                }
            }
        }

        app.radio.$on("TKComplexComponentProxyEvent",  this.eventHandlers["TKComplexComponentProxyEvent"]);
    },

    destroyed () {
        app.radio.$off("TKComplexComponentProxyEvent",  this.eventHandlers["TKComplexComponentProxyEvent"]);
    },
    methods: {
        animationComplete() {
            this.resolver && this.resolver();
        },

        onCloseClicked() {
            if (this.static.closeState) {
                if (this.static.closeState.global)
                    app.radio.$emit("setState", this.static.closeState.global);
                if (this.static.closeState.local)
                    app.radio.$emit("setStates", [
                        `${this.componentId}:${this.static.closeState.local}`,
                    ]);
            }
        },

        onStateChange(newState) {
            if (this.state.visible && this.visible) {
                this.visible = false;
                let { resolver, promise } = utils.delayedPromiseResolve();

                this.resolver = resolver;
                promise.then(() => {
                    this.visible = true;
                });
            } else {
                this.visible = this.state.visible;
            }
        },
        hasImage () {

            return Array.isArray(this.state.img) && this.state.img.length
        }
    },
};
window.registerBaseComponentConfiguration("TKPopup", { text: "" })
;
Vue.component("tk-idle-screen", {
    props: ["cfg"],
    template: `
        <div class="tk-idle-screen" @click="beforeClose">

            <div class="tk-idle-screen__loop-container">
                <video src="assets/video/idle/static-loop.mp4" muted autoplay playesinline loop />
                <video 
                    v-show="startOutro"
                    class="transition-video"
                    ref="transition"
                    src="assets/video/idle/static-loop-transition.mp4" muted playesinline preload="auto" />

                <img src="assets/img/idle/BraveTern_Idle_txt.png"  :class="{'opacity-0': startOutro}"/>


                <div class="Banner"><img src="assets/img/banner.png" ></div>
                <div class="navigator" ><img src="assets/img/Navigate_icon.png"  :class="{'opacity-0': startOutro}"></div>

            </div>
        </div>
    `,
    data() {
        return {
            startOutro: false,
        }
    },

    mounted () {
        this.eventHandlers = {
            "ended":  () => {
                this.$refs.transition.removeEventListener("ended", this.eventHandlers["ended"]);
                app.radio.$emit("idle-screen-before-close");
                this.onClose();
            }
        }
    },
    
    methods: {
        beforeClose() {
            this.startOutro = true;

            
            this.$nextTick().then(() => {
                const vid = this.$refs.transition;
                vid.addEventListener("ended", this.eventHandlers["ended"]);
                vid.play();
            })
        },
        onClose() {
            this.$emit("close");
        }
    }
});
Vue.component("tk-loader", {
    template: `
    <transition
        name="custom-classes-transition"
        :enter-active-class="enterAnimation"
        :leave-active-class="leaveAnimation"
        v-on:after-enter="afterEnterCssHook"
        v-on:after-leave="afterLeaveCssHook"
        >
        <div class="tk-loader-view tk-loader" v-if="visible && enabled">
            <div class="tk-loader__content">
                <div class="userTekst" v-html="content"></div>
                <div class="progressBar" v-if="showProgressBar">
                    <div class="fill" :style="progressStyleWidth"></div>
                </div>
                <div class="progressText" v-if="showProgressText">{{progress}}%</div>
            </div>
        </div>
    </transition>
    `,
    props: ["config"],
    mixins: [
        touchKit.BaseComponentTransitionsBehavior,
        touchKit.LoaderBehaviorMixin
    ],
   
    methods: {
        // replaces @progress with the progress
        transform (input) {
            return input.replace(/@progress/g, Math.round(this.progress));
        },
        beforeTransitionIn () {
            this.progress = 0;          
            return Promise.resolve();
        },
        transitionIn () {
            this.visible = true
            return this.transitionInCompletePromise;
        },
        transitionOut () {            
            setTimeout(()=> { this.visible = false }, 500);
            return this.transitionOutCompletePromise
        }
    },
    computed: {
        content () {
            return config.loader.content
        },
        enabled () {
            return config.loader.enabled
        },
        enterAnimation () {
            return config.loader.animation.enter;
        },
        leaveAnimation () {
            return config.loader.animation.leave;
        },
        showProgressBar () {
            return config.loader.showProgressBar;
        },
        showProgressText () {
            return config.loader.showProgressText;
        }
    }
});
Vue.component("tk-video-transition-loader", {
    mixins: [touchKit.BaseComponentTransitionsBehavior, touchKit.LoaderBehaviorMixin],
    props: ["config"],
    template: `
        <transition
            name="custom-classes-transition"
            :enter-active-class="animation.enter"
            :leave-active-class="animation.leave"
            v-on:after-enter="afterEnterCssHook"
            v-on:after-leave="afterLeaveCssHook"
            >

            <div class="tk-loader-view tk-video-transition-loader" v-if="visible">
                <video :src="src" :loop="loop" playsinline muted></video>

                <transition
                    name="progressbar-transition"
                    enter-active-class="animate__animated animate__fadeIn animation-duration-550ms"
                    leave-active-class="animate__animated animate__fadeOut animation-duration-550ms">
                        <div class="progressBar" v-if="showLoadProgressOnEnd && showBar && (progressViewType == 'progress') ">
                            <div class="progressBar_track" :style="progressStyleWidth"></div>
                        </div>
                </transition>
                <transition
                    name="spinner-transition"
                    enter-active-class="animate__animated animate__fadeIn animation-duration-550ms"
                    leave-active-class="animate__animated animate__fadeOut animation-duration-550ms">
                        <div class="spinner" v-if="showLoadProgressOnEnd && showSpinner && (progressViewType=='spinner')">
                            <div class="loader"></div>
                        </div>
                </transition>
            </div>

        </transition>
    `,
    data () {

        var defaults = config["videoLoader"];

        var objData = Object.assign({  
            showSpinner: false,
            showBar: false,
            progressViewType: "spinner",
            showLoadProgressOnEnd: true,
            src:"",
            poster: "",
            loop: false,
            animation: {
                enter: "animate__animated animate__fadeIn animation-duration-550ms",
                leave: "animate__animated animate__fadeOut animation-duration-550ms"
            }
        }, 
        defaults, 
        this.config);
        return objData;
    },
 
    destroy() {
        this.videoEvents && this.videoEvents.destroy();
    },

    methods: {
        createBindings() { 
            this.videoEvents && this.videoEvents.destroy();
            this.video = this.$el.querySelector("video");
            this.video.currentTime = 0;

            this.videoEvents = new EventBindings(this.video, {
                on: "addEventListener",
                off: "removeEventListener",
            });

            this.videoEvents.add("play", () => {
                console.log("video is playing");
            });
            this.videoEvents.add("ended", () => {
                this.onVideoEnded();
            });
        },
        onVideoEnded () {
            if(this.progress<100){
                this.showSpinner = true;
                this.showBar = true;
            }
            this.videoCompletePromiseResolver();
        },
        transitionIn() {
            this.visible = true;
            this.videoCompletePromiseResolver = null;
            this.videoCompletePromise = new Promise(resolve => {
                this.videoCompletePromiseResolver = resolve;
            });
            this.$nextTick().then(()=> {
                this.createBindings();
                this.video.play();
            })
            return this.transitionInCompletePromise;
        },
        beforeTransitionOut () {
            return this.videoCompletePromise;
        },
        transitionOut() {
            setTimeout(() => {
                this.visible = false;
                this.showBar = false;
            }, 500);
            return this.transitionOutCompletePromise;
        },
    },
});
;
const TK404 = {
    template: `
    
        <div class="page page404">
            <h1>404</h1>
        </div>
    `,
      mounted () {
        this.$nextTick().then(()=> {

            app.loaderManager.hideLoader()
        });
    },
};
const TKLogin = {
    template: `
        <div class="page page-login">
            <div class="main-agile">
                <div class="alert-close"> </div>
                <div class="content-wthree">
                <div class="circle-w3layouts"></div>
                <h2>Login</h2>
                <form v-on:submit.prevent="onSubmit">
                    <div class="inputs-w3ls">
                        <i class="fa fa-user" aria-hidden="true"></i>
                        <input type="text" placeholder="username or email" v-model="user" required="">
                    </div>
                    <div class="inputs-w3ls">
                        <i class="fa fa-key" aria-hidden="true"></i>
                        <input type="password" placeholder="password" v-model="password" required="">
          
                    </div>
                        <input type="submit" value="LOGIN"> 
                        <div class="wthree-text"> 
                            <ul> 
                                <li> <a href="#">Forgot password?</a> </li>
                            </ul>
                        </div>  
                    </form>
                </div>
                </div>
        </div>
    `,
    data () {
        return {
            user: "",
            password: ""
        }
    },

    mounted () {
        this.$nextTick().then(()=> {

            app.loaderManager.hideLoader()
        });
    },
    methods: {
        onSubmit (e) {
            

            const user = this.user;
            const pass = this.password;
            this.user = "";
            this.password = "";

            app.authentication.login(user, pass)
            .then(()=> {
                // TODO: check if the query.to is a valid route.. 
                this.$router.push(app.vm.$route.query.to || config.authentication.properties.redirectOnLogin);
            })
            .catch(e => {
                // TODO: handle login error
                console.error(e);
            })


        }
    }
}